import keycloak from "../keycloak";

// Verifica se o usuário logado tem a role informada OU está num grupo de
// mesmo nome no Keycloak (ex.: role "dev" ou grupo "/dev" — os dois dão no
// mesmo aqui). Espelha, no front, a mesma equivalência "grupo == role" que
// o backend já faz em SecurityConfig.java (extractAuthorities) — lá, um
// usuário no grupo "/dev" já recebe a authority ROLE_dev automaticamente.
//
// Precisa que a claim "groups" esteja habilitada no token (mapper "Group
// Membership" no client scope do Keycloak, com "Add to access token"
// ligado) — sem isso, keycloak.tokenParsed.groups vem undefined e a função
// cai só na checagem normal de role.
export function hasRoleOrGroup(role) {
  if (keycloak.hasRealmRole(role)) {
    return true;
  }
  const grupos = keycloak.tokenParsed?.groups || [];
  return grupos.some((grupo) => {
    const nome = grupo.startsWith("/") ? grupo.slice(1) : grupo;
    return nome === role;
  });
}
